import React from 'react';
import Strip from "../../../../../components/Strip";
import FaiBox from "../../../../../MuiComponents/FaiBox";
import {Grid, Icon, Stack} from "@mui/material";
import {TextField} from "@mui/material";
import FaiSelect from "../../../../../MuiComponents/FaiSelect";
import FormField from "../../../../../components/FormField";
import FaiButton from "../../../../../MuiComponents/FaiButton";

export interface ReturnFilters {
    search?: string;
    status?: string;
}

interface HeaderBarProps {
    filters: ReturnFilters;
    onFilterChange: (filters: ReturnFilters) => void;
}

const STATUS_OPTIONS = [
    {value: "REQUESTED", label: "Waiting for a decision"},
    {value: "APPROVED", label: "Approved"},
    {value: "REJECTED", label: "Rejected"},
];

// Filters the returns shown below as the merchant types or picks a status.
function HeaderBar({filters, onFilterChange}: HeaderBarProps) {
    return (
        <>
            <FaiBox>
                <Strip>
                    <FaiBox p={"10px 10px"}>
                        <Grid container spacing={2} alignItems="center">
                            <Grid item xs={12} md={5} lg={5}>
                                <TextField
                                    fullWidth
                                    size="small"
                                    placeholder="Search product or return reason"
                                    value={filters.search ?? ""}
                                    onChange={(e) => onFilterChange({...filters, search: e.target.value})}
                                    InputProps={{endAdornment: <Icon fontSize={"small"}>search</Icon>}}
                                />
                            </Grid>
                            <Grid item xs={12} md={5} lg={5}>
                                <FaiSelect
                                    placeholder="Return status"
                                    options={STATUS_OPTIONS}
                                    value={STATUS_OPTIONS.find((o) => o.value === filters.status) ?? null}
                                    onChange={(option: any) => onFilterChange({...filters, status: option?.value})}
                                />
                            </Grid>
                            <Grid item xs={12} md={2} lg={2} display={"flex"} alignItems={"center"} justifyContent="flex-end">
                                <FaiButton
                                    sx={{padding: "7px 12px !important", height: "34px", minHeight: 0}}
                                    variant="contained"
                                    color="white"
                                    onClick={() => onFilterChange({})}
                                >
                                    <Icon sx={{marginRight: 1}}>filter_list</Icon>
                                    Reset
                                </FaiButton>
                            </Grid>
                        </Grid>
                    </FaiBox>
                </Strip>
            </FaiBox>
        </>
    );
}

export default HeaderBar;
